import React, {Component} from 'react';
import {connect} from "react-redux";
import MaterialIcon from "../../MaterialIcon";

class CacheConstantValuesInput extends Component {

    constructor(props) {
        super(props);
       this.inputRef = React.createRef();
        this.state = {
            type: "constantValue",
            name: this.props.name || "",
            value: this.props.value || ""
        };

        this.onValueChange = this.onValueChange.bind(this);
    }
    componentDidMount() {
        if (this.props.shouldFocus) {
            this.inputRef.current.focus();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const shouldUpdateParent = (prevState.name !== this.state.name) || (prevState.value !== this.state.value) || (prevState.type !== this.state.type);

        if (shouldUpdateParent) {
            const dynProp = {
                type: this.state.type,
                name: this.state.name,
                value: this.state.value
            };
            this.props.updateconstantValue(dynProp);
        }

    }

    onValueChange(e, type) {
        const value = e.target.value;
        this.setState({[type]: value});
    }

    render() {
        return (
            <div className="prop-row">
                <div className="dyn-prop">
                    <div className="dyn-prop-row">
                        <div className="type-input">
                            <input className="dyn-prop-input" type="text" placeholder="Enter a value" value={this.state.value}
                                   ref={this.inputRef}
                                   onChange={(e) => this.onValueChange(e, "value")}/>
                        </div>
                    </div>
                </div>
                <div className="close-button"
                     onClick={() => this.props.onDelete()}>
                    <MaterialIcon icon="remove_circle"/>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        contextProperties: state.contextProperties,
        properties: state.properties
    }
}

export default connect(mapStateToProps, {})(CacheConstantValuesInput);
